import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { formatPrice } from 'Utils';
import Button from 'Components/Button';
import Accordion from 'Components/Accordion';
import Price from 'Components/Price';
import { Container, Row, Col } from 'Components/Grid';
import styles from './styles.scss';
import ConsumptionData from 'Components/ConsumptionData';

export default class ServiceBox extends React.Component {
  static propTypes = {
    headline: PropTypes.string,
    description: PropTypes.string,
    scopes: PropTypes.array,
    benefits: PropTypes.array,
    price: PropTypes.number,
    priceText: PropTypes.string,
    priceType: PropTypes.string,
    onContactClick: PropTypes.func,
    footnote: PropTypes.object,
    consumptionText: PropTypes.string,
    buttonLabel: PropTypes.string,
    trackingLabel: PropTypes.string,
  };

  render() {
    const {
      headline,
      description,
      scopes,
      benefits,
      price,
      priceText,
      priceType,
      onContactClick,
      footnote,
      consumptionText,
      buttonLabel,
      trackingLabel,
    } = this.props;

    return (
      <div className={styles.root}>
        <Container>
          <h2 className={styles.headline}>{headline}</h2>
          <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />

          <Row className={styles.accordions}>
            <Col cols={12} m={6}>
              {scopes.length > 0 && (
                <Accordion label="Leistungsumfang" collapsible={'m'}>
                  <ul className={styles.list}>
                    {scopes.map((scope) => {
                      return <li key={`scope-${scope.id}}`}>{scope.name}</li>;
                    })}
                  </ul>
                </Accordion>
              )}
            </Col>
            <Col cols={12} m={6}>
              {benefits.length > 0 && (
                <Accordion label="Vorteile" collapsible={'m'}>
                  <ul className={styles.list}>
                    {benefits.map((benefit) => {
                      return <li key={`benefit-${benefit.id}}`}>{benefit.name}</li>;
                    })}
                  </ul>
                </Accordion>
              )}
            </Col>
          </Row>
          <div className={styles.footer}>
            <div className={styles.price}>
              {priceType !== 'NONE' && (
                <Fragment>
                  <Price value={formatPrice(price)} prefix={priceType} />
                  {(priceText || footnote) && (
                    <h5>
                      {priceText}
                      {footnote && <sup>{footnote.number}</sup>}
                    </h5>
                  )}
                </Fragment>
              )}
            </div>
            <div className={styles.cta}>
              <Button
                variant="secondary"
                label={buttonLabel}
                onClick={onContactClick}
                trackingLabel={trackingLabel}
              />
            </div>
          </div>
        </Container>

        <ConsumptionData consumptionText={[consumptionText]} style={{ marginTop: '30px' }} />
      </div>
    );
  }
}
